/**
 * Wallet Geo Restriction Modal
 *
 * Shown instead of the wallet selection list when the user is in a
 * geo-restricted location. Matches the "not-whitelisted" modal pattern.
 */

import React from "react";

import { RightShortIcon } from "../assets/icons/arrows/RightShortIcon";
import { CloseIcon as CrossIcon } from "../assets/icons/v2/CloseIcon";

interface WalletGeoRestrictionModalProps {
    ip: string | undefined;
    country: string | undefined;
    onClose: () => void;
}

export function WalletGeoRestrictionModal({
    ip,
    country,
    onClose
}: WalletGeoRestrictionModalProps): React.ReactElement {
    return (
        <>
            {/* Blur Background */}
            <div
                className="fixed inset-0 bg-[#111114]/50 transition-opacity duration-300 z-40 backdrop-blur opacity-100"
                onClick={onClose}
                aria-hidden="true"
            />
            {/* Modal Content */}
            <div
                className="panel fixed z-50 w-full inset-0 m-auto max-w-screen-lg h-fit"
                onClick={(e): void => e.stopPropagation()}
            >
                <div className="menu rounded-b-md flex flex-col w-full max-h-[630px] overflow-hidden">
                    {/* Header */}
                    <div className="flex flex-col w-full px-md pt-md pb-sm gap-2xs shrink-0">
                        <div className="flex w-full items-center justify-between">
                            <h2 className="text-h2 font-bold text-foreground-base">
                                Location Restricted
                            </h2>
                            <button
                                onClick={onClose}
                                className="text-foreground-base
                                    hover:text-primary-base
                                    active:text-primary-muted
                                    transition-colors duration-200
                                    cursor-pointer"
                                aria-label="Close"
                            >
                                <CrossIcon className="w-auto h-lg" />
                            </button>
                        </div>
                        <p className="text-sm text-foreground-muted">
                            Access restricted
                        </p>
                    </div>

                    {/* Center Section - White background with IP and country */}
                    <div className="bg-white flex flex-col items-center justify-center py-2xl gap-md flex-1 min-h-0">
                        {ip && (
                            <span className="text-4xl font-bold text-black">
                                {ip}
                            </span>
                        )}
                        {country && (
                            <span className="text-sm text-black/70">
                                {country}
                            </span>
                        )}
                    </div>

                    {/* Footer Banner */}
                    <div className="bg-surface-imprint flex flex-col items-center gap-sm px-md py-md shrink-0">
                        <p className="text-xs text-foreground-muted text-center">
                            This IP address location is restricted. Wallet
                            connection is not available in your region.
                        </p>
                    </div>

                    {/* Browse Button */}
                    <div className="px-md py-md shrink-0">
                        <button
                            onClick={onClose}
                            className="btn-primary btn-sm w-full items-center cursor-pointer"
                        >
                            Browse Site
                            <RightShortIcon className="w-auto h-sm" />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
